import { render, staticRenderFns } from "./PartnerOrderRequestCreate.vue?vue&type=template&id=8b1ff4d0&scoped=true&"
import script from "./PartnerOrderRequestCreate.vue?vue&type=script&lang=js&"
export * from "./PartnerOrderRequestCreate.vue?vue&type=script&lang=js&"
import style0 from "./PartnerOrderRequestCreate.vue?vue&type=style&index=0&id=8b1ff4d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1ff4d0",
  null
  
)

export default component.exports